import React from "react";
import {DangerButton} from "../../../../components/CustomButton";
import CustomIcon from "../../../../components/CustomIcon";
import {ReactComponent as HeartSvg} from "../../../../assets/img/svgs/heart.svg";
import {ReactComponent as StarSvg} from "../../../../assets/img/svgs/star.svg";

export default function ProductLoader({mobile, isFlashSale, isHorizontal}) {
  return (
    isHorizontal ? 
      <div className="flex space-x-4 items-start w-full border p-3 rounded mb-1">
        <div className="aspect-product-image w-14 bg-rand-300 rounded"/>
          <div className="flex-1">
            <div className="w-full bg-rand-300 h-5 mb-0.5"/>
            <div className="w-28 bg-rand-300 h-4"/>
        </div> 
      </div> :
    <div className="product-size border bg-white app-rounded shrink-0 z-1">
      <div className="animate-pulse">
        <div className="w-full aspect-product-image bg-rand-300"/>
        <div className="h-0.5 bg-rand-400"/>
        <div className={`overflow-hidden ${mobile ? "p-2" : "p-3"}`}>
          <div className={`w-full bg-rand-300 mb-0.5 ${mobile ? "h-[14px]" : "h-[21px]"} mb-0.5`}/>
          <div className={`w-16 bg-rand-300 ${mobile ? "h-[14px]" : "h-[21px]"}`}/> 
          <div className={`invisible ${mobile ? "text-xs" : "text-lg"} text-center`}>
            <span className="leading-none"><span
              className={`${mobile ? "text-xxs font-medium" : "text-sm font-normal"}`}>NPR. </span>0000</span>
            <span
              className="text-error-500 font-bold border-l border-rand-100 leading-none pl-1 ml-1">0%off
              </span>
          </div>
          <div className={`mt-1 ${mobile ? "h-[10px]" : "h-[16px]"}`}/>
          {(!isFlashSale && mobile) && <div className={`space-x-2 flex items-center mt-2`}>
            <HeartSvg className={`${mobile ? "w-6" : "w-8"} opacity-50 shrink-0`}/>
            <div
              className={`app-rounded bg-rand-300 w-full ${mobile ? "h-[26px]" : "h-[36px]"}`}/>
          </div>}
        </div>
      </div>
    </div>
  );
}


export function ProductError({errorMsg, retry}) {
  return (
    <div
      className="shadow-md mr-2 product-size bg-white app-rounded flex flex-col justify-evenly h-56 relative items-center">

      <div className="text-center text-sm text-error-500 leading-none whitespace-normal">
        {errorMsg}
      </div>
      <div className="text-center">
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>

    </div>
  );
}